export const dashboardTranslations = {
  pt: {
    title: "Dashboard",
    subtitle: "Gerencie suas páginas de links e links curtos e acompanhe as quantidades de acessos",
    loading: "Carregando suas páginas...",
    errorTitle: "Não foi possível carregar",
    errorAction: "Fazer login novamente",
    planFree: "Grátis",
    whatsappSupport: "Suporte WhatsApp",
    whatsappMessage: "Olá, sou cliente do Hub Links e preciso de suporte.",
    logout: "Sair",
    createPage: "Criar nova página",
    addShortLink: "Adicionar link curto",
    metrics: {
      totalAccesses: "Acessos Totais",
      pageAccesses: "Acessos em Páginas",
      shortLinkClicks: "Cliques em Links Curtos"
    },
    tabs: {
      pages: "Páginas",
      shortLinks: "Links Curtos"
    },
    search: {
      placeholder: "Buscar por nome ou slug...",
      noResults: "Nenhuma página encontrada",
      noResultsDesc: "Não encontramos nada com \"{searchTerm}\". Tente buscar por outro termo.",
      clearSearch: "Limpar busca"
    },
    emptyState: {
      title: "Comece sua jornada",
      description: "Crie sua primeira página de links para compartilhar tudo o que você faz em um só lugar.",
      action: "Criar primeira página"
    },
    shortLinks: {
      searchPlaceholder: "Buscar links curtos...",
      card: {
        untitled: "Sem título",
        clicks: "cliques",
        delete: "Excluir",
        copy: "Copiar",
        open: "Abrir",
        viewQr: "QR Code",
        downloadQr: "Baixar QR"
      },
      toast: {
        deleteError: "Erro ao excluir link: ",
        deleteSuccess: "Link excluído com sucesso",
        copySuccess: "Link copiado para a área de transferência",
        copyError: "Erro ao copiar link",
        createSuccess: "Link curto criado com sucesso",
        qrError: "Erro ao gerar QR code"
      },
      noResultsTitle: "Nenhum link curto encontrado",
      noResultsDesc: "Nenhum link encontrado para \"{term}\".",
      emptyTitle: "Crie seu primeiro link curto",
      emptyDesc: "Encurte seus links para acompanhar cliques e compartilhá-los facilmente.",
      createCta: "Criar link curto"
    }
  },
  en: {
    title: "Dashboard",
    subtitle: "Manage your link pages and short links and track access quantities",
    loading: "Loading your pages...",
    errorTitle: "Could not load",
    errorAction: "Log in again",
    planFree: "Free",
    whatsappSupport: "WhatsApp Support",
    whatsappMessage: "Hi, I'm a Hub Links client and need support.",
    logout: "Logout",
    createPage: "Create new page",
    addShortLink: "Add short link",
    metrics: {
      totalAccesses: "Total Accesses",
      pageAccesses: "Page Accesses",
      shortLinkClicks: "Short Link Clicks"
    },
    tabs: {
      pages: "Pages",
      shortLinks: "Short Links"
    },
    search: {
      placeholder: "Search by name or slug...",
      noResults: "No page found",
      noResultsDesc: "We didn't find anything with \"{searchTerm}\". Try searching for another term.",
      clearSearch: "Clear search"
    },
    emptyState: {
      title: "Start your journey",
      description: "Create your first link page to share everything you do in one place.",
      action: "Create first page"
    },
    shortLinks: {
      searchPlaceholder: "Search short links...",
      card: {
        untitled: "Untitled",
        clicks: "clicks",
        delete: "Delete",
        copy: "Copy",
        open: "Open",
        viewQr: "QR Code",
        downloadQr: "Download QR"
      },
      toast: {
        deleteError: "Error deleting link: ",
        deleteSuccess: "Link deleted successfully",
        copySuccess: "Link copied to clipboard",
        copyError: "Error copying link",
        createSuccess: "Short link created successfully",
        qrError: "Error generating QR code"
      },
      noResultsTitle: "No short links found",
      noResultsDesc: "No links found for \"{term}\".",
      emptyTitle: "Create your first short link",
      emptyDesc: "Shorten your links to track clicks and share them easily.",
      createCta: "Create short link"
    }
  }
};
